import { apiClient } from "../Utils/apiClient";

export const getMarkListData = async () => {
  return await apiClient("get", "/v1/b2b/markingsystem");
};

export const addMarkListData = async (data) => {
  return await apiClient("post", "/v1/b2b/markingsystem/add",data);
};

export const updateMarkListData = async (data) => {
  return await apiClient("put", "/v1/b2b/markingsystem",data);
};

export const getMarkListDataById = async (id) => {
  return await apiClient("get", `/v1/b2b/markingsystem/${id}`);
};

export const deleteMarkListData = async (id) => {
  return await apiClient("delete", `/v1/b2b/markingsystem/${id}`);
};

export const updateStatus = async () => {
  return await apiClient("put", `/v1/b2b/markingsystem/status`);
};

export const changeStatus = async (data) => {
  return await apiClient("put", `v1/b2b/markingsystem/status`,data);
};